import React from 'react';
import { Link } from 'react-router-dom';
import { Activity, Clock, Users, Award, ArrowRight, MapPin } from 'lucide-react';
import './Home.css';

const Home = () => {
  const stats = [
    { icon: <Award size={20} />, value: '12+', label: 'Years Experience' },
    { icon: <Users size={20} />, value: '30k+', label: 'Patients Treated' },
    { icon: <Activity size={20} />, value: '20+', label: 'Expert Physios' },
    { icon: <Clock size={20} />, value: '98%', label: 'Recovery Rate' },
  ];

  return (
    <div className="home">
      {/* SEO HIDDEN STRUCTURED DATA */}
      <script type="application/ld+json">
        {JSON.stringify({
          "@context": "https://schema.org",
          "@type": "Physiotherapy",
          "name": "RV Physio Therapy",
          "description": "Best physiotherapy clinic in Greater Noida offering back pain treatment, sports injury rehab, stroke rehabilitation and joint pain therapy.",
          "url": "https://rvtechnologies.net.in",
          "telephone": "+917048944596",
          "email": "contact@rvtechnologies.net.in",
          "address": {
            "@type": "PostalAddress",
            "streetAddress": "Tower T3, 7th Floor, 739, Sector Techzone-IV",
            "addressLocality": "Greater Noida (West)",
            "addressRegion": "Uttar Pradesh",
            "postalCode": "201306",
            "addressCountry": "IN"
          },
          "geo": {
            "@type": "GeoCoordinates",
            "latitude": "28.4744",
            "longitude": "77.5040"
          },
          "openingHours": ["Mo-Sa 09:00-20:00"],
          "priceRange": "$$",
          "image": "https://images.unsplash.com/photo-1576091160550-2173dba999ef?w=800"
        })}
      </script>

      {/* HERO SECTION */}
      <section className="hero" role="banner">
        <div className="hero-left">
          <div className="hero-badge">
            <Activity size={16} />
            Best Physiotherapy in Greater Noida
          </div>
          <h1>Move Freely, <span>Live Fully</span></h1>
          <p>Expert physiotherapy for back pain, sports injuries, stroke recovery & joint pain. Get back to your active life with RV Physio Therapy — Greater Noida's most trusted rehabilitation center.</p>
          <div className="hero-btns">
            <Link to="/contact" className="btn-primary">
              Book Appointment <ArrowRight size={18} />
            </Link>
            <Link to="/services" className="btn-secondary">Our Services</Link>
          </div>
          <div className="hero-stats">
            {stats.map((stat, i) => (
              <div className="stat" key={i}>
                <h3>{stat.value}</h3>
                <p>{stat.label}</p>
              </div>
            ))}
          </div>
        </div>
        <div className="hero-right">
          <div className="hero-img-frame">
            <img 
              src="https://images.unsplash.com/photo-1576091160550-2173dba999ef?w=600&h=800&fit=crop" 
              alt="Physiotherapist treating patient at RV Physio Therapy Greater Noida"
            />
          </div>
          <div className="hero-float-card float-card-1">
            <div className="float-icon"><Activity size={20} /></div>
            <div className="float-text">
              <h4>Expert Physios</h4>
              <p>20+ Specialists</p>
            </div>
          </div>
          <div className="hero-float-card float-card-2">
            <div className="float-icon"><MapPin size={20} /></div>
            <div className="float-text">
              <h4>Greater Noida</h4>
              <p>Techzone-IV</p>
            </div>
          </div>
        </div>
      </section>

      {/* SERVICES PREVIEW */}
      <section className="section featured-services">
        <div className="section-header">
          <h2>Our Physiotherapy Services</h2>
          <p>Specialized treatments for every type of pain and injury</p>
        </div>
        <div className="services-preview-grid">
          {[
            { icon: '🏋️', title: 'Back Pain Treatment', desc: 'Effective relief for chronic back pain, sciatica, and spinal disorders through targeted physiotherapy.' },
            { icon: '⚽', title: 'Sports Injury Rehab', desc: 'Complete recovery programs for athletes — ACL, sprains, fractures, and muscle tears.' },
            { icon: '🧠', title: 'Stroke Rehabilitation', desc: 'Neuro-physiotherapy to restore movement, balance, and independence after stroke.' },
          ].map((s, i) => (
            <div className="service-card" key={i}>
              <div className="service-icon">{s.icon}</div>
              <h3>{s.title}</h3>
              <p>{s.desc}</p>
            </div>
          ))}
        </div>
        <div className="text-center" style={{ marginTop: '32px' }}>
          <Link to="/services" className="btn-secondary">View All Services</Link>
        </div>
      </section>

      {/* WHY CHOOSE US */}
      <section className="section why-choose">
        <div className="section-header">
          <h2>Why Choose RV Physio?</h2>
          <p>What makes us Greater Noida's preferred physiotherapy clinic</p>
        </div>
        <div className="why-grid">
          {[
            { icon: '👨‍⚕️', title: 'Certified Physiotherapists', desc: 'All our physiotherapists are BPT/MPT certified with 5+ years of clinical experience.' },
            { icon: '🏥', title: 'Modern Equipment', desc: 'Latest electrotherapy, ultrasound, laser therapy, and exercise rehabilitation machines.' },
            { icon: '📋', title: 'Personalized Plans', desc: 'Every patient gets a customized treatment plan based on their specific condition and goals.' },
            { icon: '💰', title: 'Affordable Pricing', desc: 'Quality physiotherapy at transparent prices. No hidden charges, ever.' },
          ].map((item, i) => (
            <div className="why-card" key={i}>
              <div className="why-icon">{item.icon}</div>
              <h3>{item.title}</h3>
              <p>{item.desc}</p>
            </div>
          ))}
        </div>
      </section>
    </div>
  );
};

export default Home;
